import { generateHash } from './generateHash';

export const getRandomDomId = () => {
  const leadCharacter = 'a';

  return `${leadCharacter}${generateHash()}`;
};
